import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { PropsWithChildren } from 'react'
import { useSettingsStore } from '@/store/useSettingsStore'

export default function ProtectedRoute({
  children
}: Readonly<PropsWithChildren>) {
  const privacyPolicyAccepted = useSettingsStore(
    (state) => state.privacyPolicyAccepted
  )
  const location = useLocation()

  if (!privacyPolicyAccepted) {
    return (
      <Navigate to="/acceptPrivacyPolicy" replace state={{ from: location }} />
    )
  }

  return children ?? <Outlet />
}
